module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/carrot.svg?f760a882bb6cf608e886d2048e4bebf3";